<template>  
  <div> 
    <v-simple-table class="d-none d-md-block">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" width="25%">
            {{$t("labels.MTG_RequestName")}}
          </th>
          <th class="text-left" width="50%">
             {{$t("labels.MTG_Recipients")}}
          </th>
          <th class="text-left" width="25%">
             {{$t("labels.MTG_RequestDate")}}
          </th>
           <th class="text-left"  width="25%">
             {{$t("labels.MTG_RequestDocumentLink")}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in deal.DocumentRequests"
          :key="item.DocumentRequestId"
        >
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span  v-bind="attrs" v-on="on">{{ getDisplayName(item.RequestName, 20) }}</span>
              </template>
              <span>{{item.RequestName}}</span>
            </v-tooltip>
          </td>
          <td> 
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span  v-bind="attrs" v-on="on">{{ getDisplayName(item.Recipients, 50) }}</span>
              </template>
              <span >{{item.Recipients}}</span>
            </v-tooltip>
          </td>
          <td>{{ item.SentDate }}</td>
          <td><v-btn color="primary" text @click="uploadDocument(item)">{{ $t("labels.MTG_Upload") }}</v-btn></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    <div class="d-md-none">
        <v-card  v-for="item in deal.DocumentRequests" :key="item.DocumentRequestId">
          <v-card-title>
              <span class="text-h5">{{ getDisplayName(item.RequestName, 20)}}</span><br/>                   
          </v-card-title>
          <v-card-text>
              <v-container class="text-left">
                <v-row>
                  <v-col cols="5">
                   <span class="font-weight-black">{{$t("labels.MTG_RequestName")}}</span>
                  </v-col>
                  <v-col cols="7" >
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span  v-bind="attrs" v-on="on">{{ getDisplayName(item.RequestName, 20) }}</span>
                      </template>
                      <span>{{item.RequestName}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                   <span class="font-weight-black">{{$t("labels.MTG_Recipients")}}</span>
                  </v-col>
                  <v-col cols="7">
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span  v-bind="attrs" v-on="on">{{ getDisplayName(item.Recipients, 50) }}</span>
                      </template>
                      <span >{{item.Recipients}}</span>
                    </v-tooltip>
                 
                  </v-col>
                </v-row>
                 <v-row>  
                  <v-col cols="5">
                   <span class="font-weight-black">{{$t("labels.MTG_RequestDate")}}</span>
                  </v-col>
                  <v-col cols="7">
                   <span>{{ item.SentDate}}</span>
                  </v-col>
                </v-row>
                  <v-row>
                  <v-col cols="5">
                   <span class="font-weight-black">{{$t("labels.MTG_RequestDocumentLink")}}</span>
                  </v-col>
                  <v-col cols="7">
                   <span><v-btn color="primary" text @click="uploadDocument(item)" style="padding:0px">{{ $t("labels.MTG_Upload") }}</v-btn></span>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>        
       </v-card>
    </div>
  </div>
</template>
<script>
export default {
    props:["deal"],   
    methods:{
       getDisplayName(name, length){
         if(name && name.length > length){
           return name.substring(0,length);
         }
         return name;
       },    
       uploadDocument(item){
           //this.$router.push(item.DocumentRequestUrl + "?mydeals=true");

           let routeData = this.$router.resolve({path: item.DocumentRequestUrl, query: {mydeals: "true"}});
           window.open(routeData.href, '_blank');
       }
    }
}
</script>
<style scoped>

</style>